const index = () => {
  return <h1>Blog</h1>
}

export default index
